export const dateTimeFormat = "DD-MMM-YYYY hh:mm A";
export const dateFormat = "DD-MMM-YYYY";

export const REGEX = {
  ALPHANUMERIC_4_25: /^[A-Za-z0-9]{4,25}$/,
  MAX_50_CHARS: /^.{1,50}$/,
  USERNAME_PATTERN: /^[A-Za-z0-9.-]{1,50}$/,
  PASSWORD_COMPLEX: /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$/,
  NAME_PATTERN: /^[A-Za-z ]{1,50}$/,
  EMAIL: /^[^\s@]{1,100}@[^\s@]+\.[^\s@]+$/,
  MOBILE_NUMBER: /^[0-9]{7,15}$/,
  ALPHANUMERIC_SPACES_50: /^[A-Za-z0-9\s]{1,50}$/,
  ALPHANUMERIC_50: /^[A-Za-z0-9]{1,50}$/,
};

export const PREV_DAY_DATE = new Date(
  new Date().setDate(new Date().getDate() - 1)
);